import Loadable from 'app/components/Loadable';
import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

const AllmembersGSC = Loadable(lazy(() => import('./AllmembersGSC')));
const BranchDashboard = Loadable(lazy(() => import('./BranchDashboard')));
const Importsports = Loadable(lazy(() => import('./Importsports')));
const Userreports = Loadable(lazy(() => import('./Userreports')));
const ClubAllAccess = Loadable(lazy(() => import('./ClubAllAccess')));
const Deletionrequests = Loadable(lazy(() => import('./Deletionrequests')));
const Businesses = Loadable(lazy(() => import('./Businesses')));
const Sponsors = Loadable(lazy(() => import('./Sponsors')));
const BusinessesAndSponsors = Loadable(lazy(() => import('./BusinessesAndSponsors')));
const Vouchusers = Loadable(lazy(() => import('./VouchUsers')));
const Trips = Loadable(lazy(() => import('./Trips')));
const Forum = Loadable(lazy(() => import('./Forum')));
const CreateTrip = Loadable(lazy(() => import('./CreateTrip')));
const MemberPayments = Loadable(lazy(() => import('./MemberPayments')));
const AdminBranches = Loadable(lazy(() => import('./AdminBranches')));
const BranchDetails = Loadable(lazy(() => import('./BranchDetails')));
const SuperAdminDashboard = Loadable(lazy(() => import('./SuperAdminDashboard')));
const Permissions = Loadable(lazy(() => import('./Permissions')));
const MemberDetail = Loadable(lazy(() => import('./MemberDetail')));
const CreateForumPost = Loadable(lazy(() => import('./CreateForumPost')));
const TripDetail = Loadable(lazy(() => import('./TripDetail')));
const ForumDetail = Loadable(lazy(() => import('./ForumDetail')));
const Events = Loadable(lazy(() => import('./Events')));
const CreateEvent = Loadable(lazy(() => import('./CreateEvent')));
const EventDetail = Loadable(lazy(() => import('./EventDetail')));
const Messaging = Loadable(lazy(() => import('./Messaging')));
const SmtpSettings = Loadable(lazy(() => import('./SmtpSettings')));
const Treasury = Loadable(lazy(() => import('./Treasury')));
const PlatformIssues = Loadable(lazy(() => import('./PlatformIssues')));
const ExpenseCategories = Loadable(lazy(() => import('./ExpenseCategories')));
const AppConfiguration = Loadable(lazy(() => import('./AppConfiguration')));
const Settings = Loadable(lazy(() => import('./Settings')));

const pagesRoutes = [
  // No featureCode here on purpose — see the matching note in navigations.js. AuthGuard
  // also treats this path as its own fallback/exempt route, so this featureCode was never
  // actually enforced anyway; removed to avoid the two disagreeing if that ever changes.
  { path: '/pages/branch-dashboard', element: <BranchDashboard /> },
  { path: '/pages/super-admin-dashboard', element: <SuperAdminDashboard /> },
  { path: '/pages/allmembersGSC', element: <AllmembersGSC />, featureCode: 'member_list_profiles' },
  { path: '/pages/importsports', element: <Importsports /> },
  { path: '/pages/userreports', element: <Userreports /> },
  { path: '/pages/cluballaccess', element: <ClubAllAccess /> },
  { path: '/pages/deletionrequests', element: <Deletionrequests />, featureCode: 'deletion_requests' },
  { path: '/pages/businesses', element: <Businesses /> },
  { path: '/pages/sponsors', element: <Sponsors /> },
  { path: '/pages/businesses-sponsors', element: <BusinessesAndSponsors />, featureCode: 'businesses_sponsors' },
  { path: '/pages/vouchusers', element: <Vouchusers /> },
  { path: '/pages/trips', element: <Trips /> },
  { path: '/pages/forum', element: <Forum /> },
  { path: '/pages/create-trip', element: <CreateTrip /> },
  { path: '/pages/edit-trip', element: <CreateTrip /> },
  { path: '/pages/member-payments', element: <MemberPayments />, featureCode: 'payments_subscriptions' },
  { path: '/pages/admin-branches', element: <AdminBranches />, featureCode: 'club_settings' },
  { path: '/pages/branch-details', element: <BranchDetails />, featureCode: 'club_settings' },
  { path: '/pages/permissions', element: <Permissions /> },
  { path: '/pages/member-detail', element: <MemberDetail />, featureCode: 'member_list_profiles' },
  { path: '/pages/create-forum-post', element: <CreateForumPost /> },
  { path: '/pages/trip-detail', element: <TripDetail /> },
  { path: '/pages/forum-detail', element: <ForumDetail /> },
  { path: '/pages/events', element: <Events /> },
  { path: '/pages/create-event', element: <CreateEvent /> },
  { path: '/pages/edit-event', element: <CreateEvent /> },
  { path: '/pages/event-detail', element: <EventDetail /> },
  {
    path: '/pages/messaging',
    element: <Messaging />,
    featureCode: ['announcements', 'individual_messaging'],
  },
  { path: '/pages/announcements', element: <Navigate replace to="/pages/messaging?tab=announcement" /> },
  { path: '/pages/individual-message', element: <Navigate replace to="/pages/messaging?tab=individual" /> },
  { path: '/pages/smtp-settings', element: <SmtpSettings />, featureCode: 'club_settings' },
  { path: '/pages/treasury', element: <Treasury />, featureCode: 'treasury' },
  { path: '/pages/platform-issues', element: <PlatformIssues /> },
  { path: '/pages/expense-categories', element: <ExpenseCategories /> },
  { path: '/pages/app-configuration', element: <AppConfiguration /> },
  { path: '/pages/settings', element: <Settings /> },
];

export default pagesRoutes;
